export default __webpack_public_path__ + "media/images/features/saga/logo_saga-996809d78f5f1b751ffc7092899d7ee2.png";